// extracted by mini-css-extract-plugin
module.exports = {"searchSponsoredProductsContainer":"bT","product":"cT","products":"dT","tooltipWrapper":"eT","tooltip":"fT","title":"gT"};